// Loads GA4, GTM and Microsoft Clarity only when env IDs are provided.
export function initAnalytics() {
  const GA4 = process.env.REACT_APP_GA4_ID;
  const GTM = process.env.REACT_APP_GTM_ID;
  const CLARITY = process.env.REACT_APP_CLARITY_ID;

  if (GA4) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA4);
  }

  if (GTM) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM}`;
    document.head.appendChild(s);
  }

  if (CLARITY) {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY);
  }

  // One delegated listener measures every public click-to-call link, including
  // links added to future city and service pages. GA4 receives a recommended
  // lead event plus a detailed event for reporting and Google Ads imports.
  document.addEventListener("click", (event) => {
    if (window.location.pathname.startsWith("/admin")) return;
    const link = event.target.closest?.('a[href^="tel:"]');
    if (!link) return;

    const params = {
      method: "phone",
      contact_type: "phone_call",
      link_url: link.getAttribute("href"),
      link_text: (link.textContent || link.getAttribute("aria-label") || "Call").trim().slice(0, 100),
      page_path: `${window.location.pathname}${window.location.search}`,
    };

    if (typeof window.gtag === "function") {
      window.gtag("event", "generate_lead", params);
      // This property already has qualify_lead marked as a GA4 key event, so
      // phone clicks count as conversions immediately.
      window.gtag("event", "qualify_lead", params);
      window.gtag("event", "phone_call_click", params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "phone_call_click", ...params });
    }
  });
}
